

























import { Vue, Component } from 'vue-property-decorator';
import ApiHelper from 'api-helper';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faCameraRetro } from '@fortawesome/free-solid-svg-icons';
// Utils
import Toast from '@common/helpers/toast';
import { Menu } from '@/models/menu';

// Components
import ContentLayout from '@components/layouts/Content.vue';
import DragDropFileUpload from '@/components/common/DragDropFileUpload.vue';
import DiagnosisForm from './components/DiagnosisForm.vue';
// Icons
import ListIcon from '@/assets/img/icon-diagnosis.svg';

@Component({
  components: {
    ContentLayout,
    DragDropFileUpload,
    DiagnosisForm,
  },
})
export default class Create extends Vue {
  iconHeader: any = ListIcon;
  isSubmiting = false;
  isLoading: boolean = false;
  diagnosis: Menu = new Menu();
  isImageUploading: boolean = false;

  get computedForm() {
    return this.$refs.dataForm as any;
  }

  async created() {
    library.add(faCameraRetro);
    dom.watch();
  }

  updateIsSubmiting(isSubmiting: boolean) {
    this.isSubmiting = isSubmiting;
  }

  handleChange(name, value) {
    this.$set(this.diagnosis, name, value);
  }

  handleCancel() {
    return this.$router.push({ name: 'diagnosis' });
  }

  async handleSubmit() {
    const valid = await this.computedForm.validate();
    if (!valid) { return; }

    const data = this.diagnosis.formJSONData('post');
    const formData = new FormData();

    for (const key in data) {
      if (data[key] !== null && data[key] !== '') {
        if (key === 'image' && data[key] instanceof File) {
          formData.append(key, data[key]);
        } else if (key === 'clinic_ids' && (data[key] || []).length > 0) {
          (data[key] || []).map((keyId) => {
            formData.append(`${key}[]`, keyId.toString());
            return keyId;
          });
        } else if (key === 'doctor_ids' && (data[key] || []).length > 0) {
          (data[key] || []).map((keyId) => {
            formData.append(`${key}[]`, keyId.toString());
            return keyId;
          });
        } else {
          formData.append(key, data[key]);
        }
      }
    }

    try {
      this.updateIsSubmiting(true);
      await ApiHelper.getApi('MedicalMenuApi').create(formData);
      this.updateIsSubmiting(false);
      Toast.success('登録しました');
      this.handleCancel();
    } catch (error) {
      this.updateIsSubmiting(false);
      const data = (error as any).response.data;
      Toast.error(data.message);
      if ((error as any).response.status === 422) {
        this.computedForm.setErrors((error as any).response.data.errors);
        return;
      }
    }
  }

  handleImageUploadStateChange(isUploading: boolean) {
    this.isImageUploading = isUploading;
  }
}
